module.exports = __webpack_public_path__ + "img/32-l.3cecdbe1.png";